export default {
  displayName: 'VidaWool Comparison Table',
  allowableParents: ['Section'],
};
